<nav class="navbar navbar-expand-lg navbar-light bg-light elevation">
  <div class="navbar-brand logo">
    <img class="logo_img" src="../../../../assets/images/serasajud3.png" alt="Logo SerasaJud" />
  </div>
  <div class="collapse navbar-collapse navbar-header" id="navbarSupportedContent">
    <ul *ngIf="isUserLoggedIn()" class="navbar-nav mr-auto">
      <li class="nav-item">
        <button mat-button routerLink="/ordem" [attr.data-cy]="'button-pagina-inicial'">Página Inicial</button>
      </li>
      <li class="nav-item">
        <button mat-button routerLink="/listar-ordem" [attr.data-cy]="'button-ordens-cadastradas'">Ordens Cadastradas</button>
      </li>
    </ul>
    <ul class="navbar-nav">
      <li class="nav-item" [hidden]="!isUserLoggedIn()">
        <app-session-timer [initialTime]="sessionTime" (sessionExpired)="timeOver($event)"></app-session-timer>
      </li>
    </ul>
    <div class="form-inline my-2 my-lg-0" *ngIf="isUserLoggedIn()">
      <ul class="float-right text-right dados-usuario">
        <li>
          <p class="text-right perfil nome-usuario">{{userData?.nome}}</p>
        </li>
        <li>
          <a routerLink="" (click)="logout()" [attr.data-cy]="'link-sair'">Sair</a>
        </li>
      </ul>
      <ul class="icone-usuario ">
        <li>
          <img id="u70_img" class="img " src="../../../../assets/images/ordem/u70.png" alt="Ícone do Usuário">
        </li>
      </ul>
    </div>
  </div>
</nav>
